import { render, staticRenderFns } from "./ReceptionActions.vue?vue&type=template&id=0aaa89eb&"
import script from "./ReceptionActions.vue?vue&type=script&lang=js&"
export * from "./ReceptionActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports